/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {SaveQuery} from '../model/saveQuery';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorSaveQueryService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer une nouvelle sauvegarde de requête (Save Query)
     * Cette requête permet de créer une nouvelle sauvegarde de requête (Save Query).&lt;br&gt;En cas de succès, la réponse contient un lien vers la nouvelle sauvegarde de requête (Save Query) créée et un code HTTP 201 (Created).&lt;br&gt;En cas d&#39;échec, la réponse contient un code HTTP 400 (Bad Request) et un message d&#39;erreur.&lt;br&gt;Dans ce cas, la sauvegarde de requête (Save Query) contient un identifiant lors de sa création.
     * @param saveQuery saveQuery
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSaveQueryUsingPOST(xDataStoreID: string, saveQuery: SaveQuery, observe?: 'body', reportProgress?: boolean): Observable<SaveQuery>;
    public createSaveQueryUsingPOST(xDataStoreID: string, saveQuery: SaveQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveQuery>>;
    public createSaveQueryUsingPOST(xDataStoreID: string, saveQuery: SaveQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveQuery>>;
    public createSaveQueryUsingPOST(xDataStoreID: string, saveQuery: SaveQuery, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createSaveQueryUsingPOST.');
        }

        if (saveQuery === null || saveQuery === undefined) {
            throw new Error('Required parameter saveQuery was null or undefined when calling createSaveQueryUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SaveQuery>(`${this.basePath}/api/saveQuerys`,
            saveQuery,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer une sauvegarde de requête (Save Query) par son identifiant
     * Cette requête permet de supprimer une sauvegarde de requête (Save Query) par son identifiant.&lt;br&gt; En cas de succès, la réponse contient un code HTTP 204 (NO_CONTENT).&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Chaque sauvegarde de requête (Save Query) est identifiée par son identifiant (id).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSaveQueryUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSaveQueryUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSaveQueryUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSaveQueryUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteSaveQueryUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteSaveQueryUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/saveQuerys/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les sauvegardes de requête (Save Query)
     * Cette requête permet de lister toutes les sauvegardes de requête (Save Query) par datastore et/ou affilié et/ou vue.&lt;br&gt;En cas de succès, la réponse contient un code HTTP 200 (OK) et une liste de sauvegardes de requêtes (Save Query).&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Le code datastore est obligatoire. Il faut s&#39;assurer d&#39;utiliser le code de la datastore et pas son identifiant.&lt;br&gt;Le code de vue est optionnel. Si il est renseigné, il faut s&#39;assurer d&#39;utiliser le code de la vue et pas son identifiant.&lt;br&gt;On peut également renseigner le code d&#39;un affilié du tenant. Si c&#39;est le cas, il faut utiliser son code et ne pas son identifiant.
     * @param xDataStoreID X-DataStoreID
     * @param codePartner codePartner
     * @param codeView codeView
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSaveQuerysByDatastoreUsingGET(xDataStoreID: string, codePartner?: string, codeView?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SaveQuery>>;
    public getAllSaveQuerysByDatastoreUsingGET(xDataStoreID: string, codePartner?: string, codeView?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SaveQuery>>>;
    public getAllSaveQuerysByDatastoreUsingGET(xDataStoreID: string, codePartner?: string, codeView?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SaveQuery>>>;
    public getAllSaveQuerysByDatastoreUsingGET(xDataStoreID: string, codePartner?: string, codeView?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllSaveQuerysByDatastoreUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codePartner !== undefined && codePartner !== null) {
            queryParameters = queryParameters.set('codePartner', <any> codePartner);
        }
        if (codeView !== undefined && codeView !== null) {
            queryParameters = queryParameters.set('codeView', <any> codeView);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<SaveQuery>>(`${this.basePath}/api/saveQuerys/find/${encodeURIComponent(String(xDataStoreID))}/${encodeURIComponent(String(codeView))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les sauvegardes de requête (Save Query)
     * Cette requête permet de lister toutes les sauvegardes de requête (Save Query).&lt;br&gt;En cas de succès, la réponse contient un code HTTP 200 (OK) et une liste de sauvegardes de requêtes (Save Query).
     * @param xDataStoreID X-DataStoreID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllSaveQuerysUsingGET(xDataStoreID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SaveQuery>>;
    public getAllSaveQuerysUsingGET(xDataStoreID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SaveQuery>>>;
    public getAllSaveQuerysUsingGET(xDataStoreID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SaveQuery>>>;
    public getAllSaveQuerysUsingGET(xDataStoreID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllSaveQuerysUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SaveQuery>>(`${this.basePath}/api/saveQuerys`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir une sauvegarde de requête (Save Query) par son identifiant
     * Cette requête permet d&#39;obtenir une sauvegarde de requête (Save Query) par son identifiant.&lt;br&gt; En cas de succès, la réponse contient un code HTTP 200 (OK) et la sauvegarde de requête (Save Query).&lt;br&gt;En cas d&#39;échec, la réponse contient un code HTTP 404 (Not Found) et un message d&#39;erreur si la sauvegarde de requête (Save Query) n&#39;est pas trouvée.&lt;b&gt; Note : &lt;/b&gt; Chaque sauvegarde de requête (Save Query) est identifiée par son identifiant (id).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSaveQueryUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<SaveQuery>;
    public getSaveQueryUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveQuery>>;
    public getSaveQueryUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveQuery>>;
    public getSaveQueryUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getSaveQueryUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getSaveQueryUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SaveQuery>(`${this.basePath}/api/saveQuerys/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une sauvegarde de requête (Save Query)
     * Cette requête permet de mettre à jour une sauvegarde de requête (Save Query).&lt;br&gt;En cas de succès, la réponse contient un lien vers la sauvegarde de requête (Save Query) mise à jour et un code HTTP 200 (OK).&lt;br&gt;En cas d&#39;échec, la réponse contient un code HTTP 400 (Bad Request) et un message d&#39;erreur si la saveQuery n&#39;est pas valide.&lt;br&gt;Si la modification de la sauvegarde de requête (Save Query) échoue malgré tout, la réponse contient un code HTTP 500 (Internal Server Error).
     * @param xDataStoreID X-DataStoreID
     * @param saveQuery saveQuery
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSaveQueryUsingPUT(xDataStoreID: string, saveQuery: SaveQuery, observe?: 'body', reportProgress?: boolean): Observable<SaveQuery>;
    public updateSaveQueryUsingPUT(xDataStoreID: string, saveQuery: SaveQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveQuery>>;
    public updateSaveQueryUsingPUT(xDataStoreID: string, saveQuery: SaveQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveQuery>>;
    public updateSaveQueryUsingPUT(xDataStoreID: string, saveQuery: SaveQuery, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateSaveQueryUsingPUT.');
        }

        if (saveQuery === null || saveQuery === undefined) {
            throw new Error('Required parameter saveQuery was null or undefined when calling updateSaveQueryUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<SaveQuery>(`${this.basePath}/api/saveQuerys`,
            saveQuery,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour une sauvegarde de requête (Save Query)
     * Cette requête permet de mettre à jour une sauvegarde de requête (Save Query).&lt;br&gt;En cas de succès, la réponse contient un lien vers la sauvegarde de requête (Save Query) mise à jour et un code HTTP 200 (OK).&lt;br&gt;En cas d&#39;échec, la réponse contient un code HTTP 400 (Bad Request) et un message d&#39;erreur si la saveQuery n&#39;est pas valide.&lt;br&gt;Si la modification de la sauvegarde de requête (Save Query) échoue malgré tout, la réponse contient un code HTTP 500 (Internal Server Error).
     * @param xDataStoreID X-DataStoreID
     * @param saveQuery saveQuery
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSaveQueryPartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: string[], observe?: 'body', reportProgress?: boolean): Observable<SaveQuery>;
    public updateSaveQueryPartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: string[], observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SaveQuery>>;
    public updateSaveQueryPartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: string[], observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SaveQuery>>;
    public updateSaveQueryPartnersUsingPUT(xDataStoreID: string, id: string, affectedPartners: string[], observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateSaveQueryPartnersUsingPUT.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateSaveQueryPartnersUsingPUT.');
        }

        if (affectedPartners === null || affectedPartners === undefined) {
            throw new Error('Required parameter affectedPartners was null or undefined when calling updateSaveQueryPartnersUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<SaveQuery>(`${this.basePath}/api/saveQuerys/${encodeURIComponent(String(id))}/partners`,
            affectedPartners,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
